import React, { useState, createContext } from "react";

export const PopUpContext = createContext();

PopUpContext.displayName = "PopUpContext";

export const PopUpProvider = ({ children }) => {
  const [popUp, togglePopUp] = useState(new Object());

  return (
    <PopUpContext.Provider
      value={{
        popUp,
        togglePopUp,
      }}
    >
      {children}
    </PopUpContext.Provider>
  );
};
